import { DateService, PulseEnvironment } from '@pulse/browser-shared';
import { Observable } from 'rxjs';
import { RequestStats } from '../request-stats';
import { patchXHR } from './xhr.patch';

export class XHRCollectorService {
    private stream?: Observable<RequestStats>;

    constructor(
        private date: DateService,
        private env: PulseEnvironment,
    ) {}

    requests() {
        if (!this.stream) {
            this.stream = patchXHR(this.date, this.env);
        }

        return this.stream;
    }
}
